document.addEventListener('DOMContentLoaded', function () {

    const accordions = document.querySelectorAll('.MainAcrodion');

    accordions.forEach(function(item) {

        const heading = item.querySelector('.AccFaq_Heading');
        const content = item.querySelector('.Acc_Content');

        // Open default active accordion
        if (heading.classList.contains('active-acc-pro')) {
            content.style.maxHeight = content.scrollHeight + 'px';
        }

        heading.addEventListener('click', function () {

            const isOpen = heading.classList.contains('active-acc-pro');

            // Close all accordions
            accordions.forEach(function(acc) {
                acc.querySelector('.AccFaq_Heading').classList.remove('active-acc-pro');
                acc.querySelector('.Acc_Content').style.maxHeight = null;
            });

            // Open clicked accordion
            if (!isOpen) {
                heading.classList.add('active-acc-pro');
                content.style.maxHeight = content.scrollHeight + 'px';
            }

        });

    });

});
